import {Dispatch, SetStateAction, useState} from "react";
import {Phone} from "../../api-client";

export interface LegalEntityDataContext {
  jobPosition: string;
  setJobPosition: Dispatch<SetStateAction<string>>;
  innLegalEntity: string;
  setInnLegalEntity: Dispatch<SetStateAction<string>>;
  companyName: string;
  setCompanyName: Dispatch<SetStateAction<string>>;
  companyKpp: string;
  setCompanyKpp: Dispatch<SetStateAction<string>>;
  companyAddress: string;
  setCompanyAddress: Dispatch<SetStateAction<string>>;
  phone: Phone;
  setPhone: Dispatch<SetStateAction<Phone>>;
}

export const useLegalEntityData = () => {
  const [jobPosition, setJobPosition] = useState("");
  const [innLegalEntity, setInnLegalEntity] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyKpp, setCompanyKpp] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [phone, setPhone] = useState(new Phone('+7', ''));
  return {
    jobPosition,
    setJobPosition,
    innLegalEntity,
    setInnLegalEntity,
    companyName,
    setCompanyName,
    companyKpp,
    setCompanyKpp,
    companyAddress,
    setCompanyAddress,
    phone,
    setPhone,
  };
};
